document.addEventListener('DOMContentLoaded', function () {
   function update(form) {
      form.querySelectorAll('.wcl-form__conditional').forEach(function (block) {
         var checked = form.querySelector('[name="' + block.dataset.showIf + '"]:checked');
         var show = !!checked && checked.value === block.dataset.showValue;

         block.hidden = !show;

         block.querySelectorAll('input, textarea, select').forEach(function (el) {
            el.disabled = !show;
         });
      });
   }

   document.addEventListener('change', function (e) {
      var form = e.target.closest('.wpcf7-form');
      if (form) update(form);
   });

   // After resetting the form, update the conditional fields.
   document.addEventListener('wpcf7reset', function (e) {
      var form = e.target.querySelector('.wpcf7-form') || e.target;

      setTimeout(function () {
         update(form);
      }, 0);
   });

   // Initialization of all forms upon page load
   document.querySelectorAll('.wpcf7-form').forEach(update);
});